import React from 'react'
import Text from '../../../../components/Text'
import Button from '../../../../components/ButtonNew'
import documentIcon from '../../../../assets/icons/document.svg'

const UnderReviewCard = ({ onViewDocuments }) => {
  return (
    <div className="bg-white rounded-[20px] p-5 z-20 -mt-14 relative shadow-[0px_4px_40px_0px_rgba(141,121,172,0.60)] space-y-1">
      <Text tag="p" variant="title" size="large" className="text-[#1F2933]">
        Care Specialist is preparing your treatment journey
      </Text>
      <Text tag="p" variant="body" size="medium" className="text-[#5A6774]">
        Documents are under review. This will take upto{' '}
        <span className="font-semibold">24 hours.</span>
      </Text>
      <div className="px-5 pt-4">
        <Button fullWidth onClick={onViewDocuments}>
          <img src={documentIcon} alt="View Documents" className="w-6 h-6" />
          View Documents
        </Button>
      </div>
    </div>
  )
}

export default UnderReviewCard
